<template>
  <div class="table-toolbar">
    <label class="table-toolbar__search">
      <Search :size="18" aria-hidden="true" />

      <input
        :value="search"
        type="search"
        :placeholder="placeholder"
        aria-label="Поиск в таблице"
        @input="$emit('search', $event.target.value)"
      >
    </label>

    <slot />

    <label class="table-toolbar__size">
      Строк на странице

      <select
        :value="pageSize"
        @change="$emit('page-size', Number($event.target.value))"
      >
        <option
          v-for="size in [10, 25, 50, 100]"
          :key="size"
          :value="size"
        >
          {{ size }}
        </option>
      </select>
    </label>
  </div>
</template>

<script>
import { Search } from 'lucide-vue'

export default {
  name: 'TableToolbarV2',
  components: { Search },
  props: {
    search: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Поиск…'
    },
    pageSize: {
      type: Number,
      default: 25
    }
  }
}
</script>

<style scoped lang="scss" src="./style.scss"/>
